import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { Quote } from '../types/quote.type';
import { QUOTES_API_PATHS } from '../constants/quotes-paths.constants';

type UseReadyQuoteResult = {
  readyQuote: (id: string) => Promise<Quote | null>;
  isSubmitting: boolean;
};

export function useReadyQuote(): UseReadyQuoteResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const readyQuote = async (id: string): Promise<Quote | null> => {
    setIsSubmitting(true);

    try {
      const quote = await HttpClient.post<Quote>(QUOTES_API_PATHS.READY(id), {});

      enqueueSnackbar('Devis marqué comme prêt', { variant: 'success' });
      return quote;
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(error, 'Une erreur est survenue lors du passage du devis en statut prêt'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { readyQuote, isSubmitting };
}
